import React from 'react'
import PdfLabel from '../../PdfLabel'

const PrintLabelPreview = ({
  output,
  labelConfig,
  layoutConfig,
  asset,
  fields,
  qrCode,
  copies,
}) => {
  if (!asset || !qrCode) {
    return null
  }

  if (output === 'label') {
    return (
      <div
        style={{
          width: '100%',
          maxWidth: 240,
          aspectRatio: `${labelConfig.width} / ${labelConfig.height}`,
          background: '#fff',
          boxSizing: 'border-box',
          border: '1px solid #ddd',
          padding: 12,
          display: 'flex',
          alignItems: 'stretch',
        }}
      >
        <div
          style={{
            width: '100%',
            height: '100%',
            border: '1px dashed #999',
            boxSizing: 'border-box',
          }}
        >
          <PdfLabel
            qrCode={qrCode}
            name={asset.name}
            code={asset.code}
            serial={asset.details.serial_number}
            category={asset.category.name}
            manufacturer={asset.details.manufacturer}
            width={100}
            height={100}
            fields={fields}
            preview={true}
          />
        </div>
      </div>
    )
  }

  const labelsPerPage =
    layoutConfig.columns * layoutConfig.rows

  const totalCopies = Math.max(
    0,
    Number(copies) || 0
  )


  const labels = Array.from(
    { length: labelsPerPage },
    (_, index) => index < totalCopies
  )

  return (
    <div
      style={{
        width: '100%',
        maxWidth: 600,
        aspectRatio: '210 / 297',
        background: '#fff',
        boxSizing: 'border-box',

        paddingTop: `${(
          layoutConfig.marginTop / 297
        ) * 100}%`,

        paddingRight: `${(
          layoutConfig.marginRight / 210
        ) * 100}%`,

        paddingBottom: `${(
          layoutConfig.marginBottom / 297
        ) * 100}%`,

        paddingLeft: `${(
          layoutConfig.marginLeft / 210
        ) * 100}%`,

        display: 'grid',

        gridTemplateColumns: `repeat(
          ${layoutConfig.columns},
          1fr
        )`,

        gridTemplateRows: `repeat(
          ${layoutConfig.rows},
          1fr
        )`,

        columnGap: `${(
          layoutConfig.columnGap / 210
        ) * 100}%`,

        rowGap: `${(
          layoutConfig.rowGap / 297
        ) * 100}%`,
      }}
    >
      {labels.map((hasLabel, index) => (
        <div
          key={index}
          style={{
            minWidth: 0,
            minHeight: 0,
            width: '100%',
            height: '100%',
            boxSizing: 'border-box',
            border: '1px dashed #999',
            overflow: 'hidden',
          }}
        >
          {hasLabel && (
            <PdfLabel
              qrCode={qrCode}
              name={asset.name}
              code={asset.code}
              serial={asset.details.serial_number}
              category={asset.category.name}
              manufacturer={asset.details.manufacturer}
              width={layoutConfig.width}
              height={layoutConfig.height}
              fields={fields}
              preview
            />
          )}
        </div>
      ))}
    </div>
  )
}

export default PrintLabelPreview